import styled from 'styled-components';
import Box from '@spotnana/pixel-react/dist/Box';

const ClickableBox = styled(Box)({ cursor: 'pointer', outline: 0 });

export default ClickableBox;
